import React from "react";

import InternalLink from "../InternalLink";

import styles from "./statCircle.module.css";

interface Props {
  color: string;
  title: string;
  text: string;
  boldText?: string;
  noPlan?: boolean;
}
const StatCircle: React.FC<Props> = ({
  color,
  title,
  text,
  boldText,
  noPlan,
}) => {
  return (
    <div style={{ backgroundColor: `${color}` }} className={styles.container}>
      <div className={styles.innerCircle}>
        <div
          className={styles.textContainer}
          style={noPlan ? { cursor: "pointer" } : null}
        >
          {noPlan ? (
            <InternalLink href="/collection">
              <div className={styles.title}>Select Plan</div>
            </InternalLink>
          ) : (
            <>
              <div className={styles.title}>{title}</div>
              <div className={styles.text}>{text} </div>
              {boldText && <div className={styles.boldText}>{boldText} </div>}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatCircle;
